import { Button } from '@consigli/facade';
import {
  useBuildingPackageId,
  useLazyGetBuildingPackageBuildingJsonQuery,
  useProjectId,
} from '@consigli/hooks';
import { saveJson } from '@consigli/utils';
import { FC, useCallback } from 'react';

export const DownloadBuildingJsonButton: FC = () => {
  const projectId = useProjectId();
  const buildingPackageId = useBuildingPackageId();

  const [getBuildingJSON] = useLazyGetBuildingPackageBuildingJsonQuery();

  const downloadJSON = useCallback(async () => {
    const buildingJSON = await getBuildingJSON({ projectId, buildingPackageId }).unwrap();
    if (buildingJSON) {
      saveJson('updatedjson.json', buildingJSON);
    } else {
      console.error('Failed to download JSON: buildingJSON is null');
    }
  }, [buildingPackageId, getBuildingJSON, projectId]);

  return (
    <Button secondary rounded onClick={downloadJSON}>
      Download building JSON
    </Button>
  );
};
